import { AnimationEvent, animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Store } from '@ngrx/store';

import { QuickBetActions } from '../quick-bet-actions';

@Component({
    selector: 'bs-quick-bet-help',
    templateUrl: './quick-bet-help.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-help.component.scss'],
    animations: [trigger('fade', [state('out', style({ opacity: 0 })), transition('in => out', animate(800, style({ opacity: 0 })))])],
    standalone: false,
})
export class QuickBetHelpComponent {
    constructor(
        public sitecore: Sitecore,
        private store: Store,
    ) {}

    isFade = signal(false);

    close = () => this.store.dispatch(QuickBetActions.helpCloseClick());

    closeWithAnimation() {
        this.isFade.set(true);
    }

    animationDone(event: AnimationEvent) {
        if (event.toState === 'out') {
            this.close();
        }
    }
}
